import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import english_messages from '../i18n/en';
export var ENGLISH_LOCALES = ['en', 'en-US', 'en-GB'];
function getMessages(_x) {
  return _getMessages.apply(this, arguments);
}
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */
function _getMessages() {
  _getMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(locale) {
    var messages;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.t0 = locale;
          _context2.next = _context2.t0 === 'cs' ? 3 : _context2.t0 === 'da' ? 5 : _context2.t0 === 'de' ? 7 : _context2.t0 === 'en' ? 9 : _context2.t0 === 'en_GB' ? 11 : _context2.t0 === 'en_ZZ' ? 13 : _context2.t0 === 'es' ? 15 : _context2.t0 === 'et' ? 17 : _context2.t0 === 'fi' ? 19 : _context2.t0 === 'fr' ? 21 : _context2.t0 === 'hu' ? 23 : _context2.t0 === 'is' ? 25 : _context2.t0 === 'it' ? 27 : _context2.t0 === 'ja' ? 29 : _context2.t0 === 'ko' ? 31 : _context2.t0 === 'nb' ? 33 : _context2.t0 === 'nl' ? 35 : _context2.t0 === 'pl' ? 37 : _context2.t0 === 'pt_BR' ? 39 : _context2.t0 === 'pt_PT' ? 41 : _context2.t0 === 'ro' ? 43 : _context2.t0 === 'ru' ? 45 : _context2.t0 === 'sk' ? 47 : _context2.t0 === 'sv' ? 49 : _context2.t0 === 'th' ? 51 : _context2.t0 === 'tr' ? 53 : _context2.t0 === 'uk' ? 55 : _context2.t0 === 'vi' ? 57 : _context2.t0 === 'zh' ? 59 : _context2.t0 === 'zh_TW' ? 61 : 63;
          break;
        case 3:
          messages = import('../i18n/cs');
          return _context2.abrupt("break", 64);
        case 5:
          messages = import('../i18n/da');
          return _context2.abrupt("break", 64);
        case 7:
          messages = import('../i18n/de');
          return _context2.abrupt("break", 64);
        case 9:
          messages = import('../i18n/en');
          return _context2.abrupt("break", 64);
        case 11:
          messages = import('../i18n/en_GB');
          return _context2.abrupt("break", 64);
        case 13:
          messages = import('../i18n/en_ZZ');
          return _context2.abrupt("break", 64);
        case 15:
          messages = import('../i18n/es');
          return _context2.abrupt("break", 64);
        case 17:
          messages = import('../i18n/et');
          return _context2.abrupt("break", 64);
        case 19:
          messages = import('../i18n/fi');
          return _context2.abrupt("break", 64);
        case 21:
          messages = import('../i18n/fr');
          return _context2.abrupt("break", 64);
        case 23:
          messages = import('../i18n/hu');
          return _context2.abrupt("break", 64);
        case 25:
          messages = import('../i18n/is');
          return _context2.abrupt("break", 64);
        case 27:
          messages = import('../i18n/it');
          return _context2.abrupt("break", 64);
        case 29:
          messages = import('../i18n/ja');
          return _context2.abrupt("break", 64);
        case 31:
          messages = import('../i18n/ko');
          return _context2.abrupt("break", 64);
        case 33:
          messages = import('../i18n/nb');
          return _context2.abrupt("break", 64);
        case 35:
          messages = import('../i18n/nl');
          return _context2.abrupt("break", 64);
        case 37:
          messages = import('../i18n/pl');
          return _context2.abrupt("break", 64);
        case 39:
          messages = import('../i18n/pt_BR');
          return _context2.abrupt("break", 64);
        case 41:
          messages = import('../i18n/pt_PT');
          return _context2.abrupt("break", 64);
        case 43:
          messages = import('../i18n/ro');
          return _context2.abrupt("break", 64);
        case 45:
          messages = import('../i18n/ru');
          return _context2.abrupt("break", 64);
        case 47:
          messages = import('../i18n/sk');
          return _context2.abrupt("break", 64);
        case 49:
          messages = import('../i18n/sv');
          return _context2.abrupt("break", 64);
        case 51:
          messages = import('../i18n/th');
          return _context2.abrupt("break", 64);
        case 53:
          messages = import('../i18n/tr');
          return _context2.abrupt("break", 64);
        case 55:
          messages = import('../i18n/uk');
          return _context2.abrupt("break", 64);
        case 57:
          messages = import('../i18n/vi');
          return _context2.abrupt("break", 64);
        case 59:
          messages = import('../i18n/zh');
          return _context2.abrupt("break", 64);
        case 61:
          messages = import('../i18n/zh_TW');
          return _context2.abrupt("break", 64);
        case 63:
          throw new Error('Unknown locale: ' + locale);
        case 64:
          _context2.next = 66;
          return messages;
        case 66:
          return _context2.abrupt("return", _context2.sent.default);
        case 67:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getMessages.apply(this, arguments);
}
export var getMessagesForLocale = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var parentLocale;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          locale = locale.replace('-', '_');
          _context.prev = 1;
          _context.next = 4;
          return getMessages(locale);
        case 4:
          return _context.abrupt("return", _context.sent);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
        case 9:
          _context.prev = 9;
          parentLocale = locale.split(/[-_]/)[0];
          _context.next = 13;
          return getMessages(parentLocale);
        case 13:
          return _context.abrupt("return", _context.sent);
        case 16:
          _context.prev = 16;
          _context.t1 = _context["catch"](9);
        case 18:
          return _context.abrupt("return", english_messages);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 7], [9, 16]]);
  }));
  return function getMessagesForLocale(_x2) {
    return _ref.apply(this, arguments);
  };
}();